import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setLoggedInUser, storeToken } from "../../redux/action";
import styles from "./login.module.css";
import GitHubIcon from "@material-ui/icons/GitHub";
// import TwitterIcon from '@material-ui/icons/Twitter';
// import GTranslateIcon from "@material-ui/icons/GTranslate";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import FacebookIcon from "@material-ui/icons/Facebook";
// import Twitter from "@material-ui/icons/Twitter";

const Container = styled.div`
width: 80%;
height: 560px;
background-color: white;
margin: 39px auto;
padding:15px;
border-radius: 15px;
/* box-shadow: 1px 1px 1px grey; */
box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
h2 {
    font-size: 30px;
    text-align: center;
}
`;
const HeadDiv = styled.div`
border: 1px solid red;
margin: 10px auto;
width: 70%;
`;
const FormDiv = styled.div`
width: 75%;
display: flex;
flex-direction: column;
margin: auto;
margin: auto;
div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px;
}
`;


export function Login() {
    const loggedIn = useSelector(state => state.loggedIn);
    const history = useHistory();
    const dispatch = useDispatch();
    const [loginData, setLoginData] = useState("");
    const url = process.env.REACT_APP_url;

    useEffect(() => {
        if (loggedIn) {
            history.push("/homepage");
        }
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLoginData({ ...loginData, [name]: value });
    }
    
    const handleLogin = (e) => {
        e.preventDefault();
        const config = {
            method: "post",
            data: loginData,
            url: `${url}/login`
        };
        axios(config)
            .then((data) => {
                // console.log(data.data.token);
                dispatch(storeToken(data.data));
                axios.get(`${url}/users/email/${loginData.email}`)
                    .then((data) => {
                        dispatch(setLoggedInUser(data.data.user));
                        history.push("/homepage");
                    })
                    .catch((err) => {
                        alert(err);
                    })
            })
            .catch((err) => {
                alert(err);
            })
    }
    return (
        <div className={styles.outerDiv} >
            <div className={styles.logoDiv}>
                <img style={{cursor:"pointer"}} onClick={() => history.push("/")} src="https://hash-node.vercel.app/static/media/hashnode.76db81e9.svg" alt="hashnode_logo"/>
            </div>
            {/* <h1 style={{fontSize:"49px", color:"rgb(51,51,51)", textAlign:"center"}}>hashnode</h1> */}
        <Container>
            {/* <HeadDiv>
            </HeadDiv> */}
            <h2>Login</h2>
                <form onSubmit={handleLogin}>
                    <FormDiv>
                        <div>
                            <p className={styles.labels}>Email Address</p>
                            <input className={styles.inpBox} name="email" onChange={handleChange} placeholder="Enter your email"/>
                        </div>
                        <div>
                            <p className={styles.labels}>Password</p>
                            <input className={styles.inpBox} type="password" name="password" onChange={handleChange} placeholder="Enter your password"/>
                        </div>
                    </FormDiv>
            <div style={{marginTop:"39px"}} className={styles.btnDiv}>
                        <input className={styles.btnSpl} type="submit" value="Login" />
                        <div style={{display:"flex", alignItems:"center"}}>
                <p style={{color:"#242627"}}>Don't have an account?</p>
            <button className={styles.btnSpl} onClick={() => history.push("/signup")}>Signup</button>
            </div>
                    </div>
                  
                </form>
                <span style={{color:"grey", position:"relative", bottom:"-7%", left:"129px"}}>Or, connect with...</span>
                <div className={styles.otherLoginOpts}>
                    <div style={{ backgroundColor: "rgb(51,51,51)", color: "white", display:"flex", alignItems:"center" }}>
                        <GitHubIcon style={{marginRight:"8px"}}/>
                        <span>GitHub</span>
                    </div>
                    <div style={{ backgroundColor:"black", color:"white",display:"flex", alignItems:"center", border:"1px solid #acaaaa" }}>
                        <div style={{height:"25px", width:"25px", marginRight:"8px"}}><img style={{width:"100%", height:"100%"}} src="/images.png" alt="google"/></div>
                        <span>Google</span>
                    </div>
                    <div style={{ backgroundColor:"rgb(59,89,152)", color: "white", display:"flex", alignItems:"center" }}>
                        <FacebookIcon style={{marginRight:"8px"}}/>
                        <span>Facebook</span>
                    </div>
                    <div style={{ backgroundColor:"rgb(0,119,181)", color: "white", display:"flex", alignItems:"center" }}>
                        <LinkedInIcon style={{marginRight:"8px"}}/>
                        <span>LinkedIn</span>
                    </div>
                    {/* <div style={{border:"1px solid grey", color:"grey"}}>Google</div>
                    <div style={{backgroundColor:"rgb(59,89,152)", color:"white"}}>Facebook</div>
                    <div style={{backgroundColor:"rgb(0,119,181)", color:"white"}}>LinkedIn</div> */}
                </div>
        </Container>
        </div>
    )
}